import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=0363bc51"
import script from "./CustomerIndex.vue?vue&type=script&lang=ts"
export * from "./CustomerIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports